import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const runCycleCountRule = unaryRpc({
  name: "runCycleCountRule" as const,
  input: z.object({ ruleId: cycleCountRuleIdFormat.schema }),
  output: z.object({ generatedCount: z.int(), productCount: z.int() }),
});
